import { OverlayDialog, RenderHtml } from '@flos/react-components';
import { FormEvent, Fragment } from 'react';
import { ROUTE_NAMES } from '../../router/RouterApp';
import { track } from 'c9-tracking';
import { getCurrentStep, getStepCount } from '../../common/utils/helpers/GenericHelpers';
import { Button } from '@material-ui/core';
import { useGlobalState } from '../../common/context/AppContext';
import getHippoText from '../../common/services/HippoTextService';

interface IProps {
    show: boolean;
    modalStateHandler: Function;
}

export const GoToMitModal = ({ show, modalStateHandler }: IProps): JSX.Element => {
    const globalState = useGlobalState();
    const hippoTexts = getHippoText(globalState.section, 'onsa.intro');

    const overlaySubmitEventHandler = (e: FormEvent) => {
        e.preventDefault();
        track.step(getCurrentStep(ROUTE_NAMES.INTRO), getStepCount());
        const siteConfig = window.topContext.config.getSiteConfig();
        const sisterHost = siteConfig.sisterHost || 'mit.topdanmark.dk';
        window.location.assign(`https://${sisterHost}`);
    };

    return (
        <OverlayDialog
            open={show}
            onClose={() =>
                window.location.assign(
                    `https://${window.topContext.config.getSiteConfig().sisterHost || 'mit.topdanmark.dk'}`
                )
            }
            transitionDuration={0}
        >
            <Fragment>
                <RenderHtml html={globalState.contentBlocks.addresspage_loggedin_hascontent_same} />
                <form
                    onSubmit={overlaySubmitEventHandler}
                    name={`onsa-content-form-content-same`}
                    id={`onsa-content-form-content-same`}
                >
                    <Button type={'submit'} fullWidth variant="contained">
                        {hippoTexts['gotomit']}
                    </Button>
                </form>
            </Fragment>
        </OverlayDialog>
    );
};
